import { render, staticRenderFns } from "./StyleCardBrands.vue?vue&type=template&id=8c91d464"
import script from "./StyleCardBrands.vue?vue&type=script&lang=js"
export * from "./StyleCardBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c91d464')) {
      api.createRecord('8c91d464', component.options)
    } else {
      api.reload('8c91d464', component.options)
    }
    module.hot.accept("./StyleCardBrands.vue?vue&type=template&id=8c91d464", function () {
      api.rerender('8c91d464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/StyleCard/StyleCardBrands.vue"
export default component.exports